import {useNavigate} from "react-router";

export const EmptyMetrcWidget = ({plantId, props}) => {
    const navigate = useNavigate();

    const onClick = () => {
        navigate(`/cultivationapp/plant/${plantId}`)
    }

    const style = {
        color: 'red',
        cursor: 'pointer'
    }
    return <div onClick={onClick} style={style}>
        <b>
            Enter Metrc
        </b>
    </div>
}